import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBz95Vf7f7Q0wjMptjR5cGE5gSU6XU4gWk",
  authDomain: "msbienesraices-d5e9f.firebaseapp.com",
  projectId: "msbienesraices-d5e9f",
  storageBucket: "msbienesraices-d5e9f.appspot.com",
  messagingSenderId: "651162454339",
  appId: "1:651162454339:web:96b33f45c1c070e08a87f6",
  measurementId: "G-CLP87SPDVE",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app); 

export { auth, db, storage };
